import React, { useEffect, useState } from 'react';
import { Drawer } from '@mui/material';
import CommonDialog from './components/CommonDialog';
import IntlMessages from 'Util/IntlMessages';
import AddressNewPopup from 'Components/Popup/AddressNewPopup';
import DateForm from './components/DateForm';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import AddressVietnamPopup from 'Components/Popup/AddressVietnamPopup';
import { isVietnam } from 'Util/DataUtils';
import icArrowRight1 from 'Assets/img/sidebar/ic_arrow_right_20_gray.png';
import icArrowRight2 from 'Assets/img/sidebar/ic_arrow_right_20_gray@2x.png';
import icArrowRight3 from 'Assets/img/sidebar/ic_arrow_right_20_gray@3x.png';
import icPin1 from 'Assets/img/header/ic_pin_blue.png';
import icPin2 from 'Assets/img/header/ic_pin_blue@2x.png';
import icPin3 from 'Assets/img/header/ic_pin_blue@3x.png';
import { getImageSet } from 'Util/DataUtils';
import DrawerSelectInput from 'Components/Input/DrawerSelectInput';
import Options from 'Constants/Options';
import useFieldAddUpdate from './hooks/useFieldAddUpdate';
import UpdatePopup from 'Routes/field/detail/SettingSection/components/Staff/UpdatePopup';
import { Input } from 'reactstrap';
import KoUpdatePopup from 'Routes/field/detail/SettingSection/components/StaffKo/UpdatePopup';
import { setMoveFloatingButton } from 'Actions';

const icArrowRight = getImageSet([icArrowRight1, icArrowRight2, icArrowRight3]);
const icPin = getImageSet([icPin1, icPin2, icPin3]);

const FieldAddUpdateDrawer = ({ open, onClose: _onClose, fieldId }) => {
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  const { formatMessage } = useIntl();
  const [openAddressPopup, setOpenAddressPopup] = useState(false);
  const [openAddressVietnamPopup, setOpenAddressVietnamPopup] = useState(false);
  const [openStaffUpdatePopup, setOpenStaffUpdatePopup] = useState(false);
  const [openStaffKoUpdatePopup, setOpenStaffKoUpdatePopup] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useSelector(state => state.authUser);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setMoveFloatingButton({ bottom: 20, right: 20 }));
    _onClose();
  };

  const { fieldData, onChangeFieldData, onConfirm, refreshStaffs } = useFieldAddUpdate({ open, fieldId, onClose });
  const { name, constructStatus, address, address2, dateConstructStart, dateConstructEnd, spaceType, staffs, memo } = fieldData;

  useEffect(() => {
    if (!open) return;
    setError(null);
    dispatch(setMoveFloatingButton({ bottom: 20, right: 420 }));
  }, [open, dispatch]);

  const onHandleAddressPopup = e => {
    e.stopPropagation();
    if (isVietnam(user)) {
      setOpenAddressVietnamPopup(true);
    } else {
      setOpenAddressPopup(true);
    }
  };

  const constructStatusMenuItems = Options.constructStatus.map(item => ({
    label: formatMessage({ id: item.label }),
    value: item.value,
  }));

  const handleTextareaHeight = e => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  return (
    <Drawer anchor='right' open={open} onClose={() => setShowCancelPopup(true)} data-field-toggle='true'>
      <div className='field-update-drawer'>
        <div className='field-update-title'>
          <IntlMessages id={fieldId ? 'field.basic.info.setting' : 'sidebar.material.field.create'} />
        </div>
        <div className='field-update-contents'>
          <div className='field-update-input-wrapper'>
            <div className='field-update-input-title'>
              <IntlMessages id='field.name' />
              <span className='required'>*</span>
            </div>
            <input
              className={`field-update-input ${error === 'name' && 'error'}`}
              value={name}
              onChange={e => {
                setError(null);
                onChangeFieldData('name', e.target.value);
              }}
              placeholder={formatMessage({ id: 'consult.customer.create.fieldName.placeholder' })}
            />
          </div>
          <div className='field-update-input-wrapper'>
            <div className='field-update-input-title'>
              <IntlMessages id='field.add.update.constructStatus' />
              <span className='required'>*</span>
            </div>
            <DrawerSelectInput
              placeholder='field.add.update.constructStatus.placeholder'
              error={error === 'constructStatus'}
              value={constructStatus}
              onChange={value => {
                setError(null);
                onChangeFieldData('constructStatus', value);
              }}
              menuItems={constructStatusMenuItems}
            />
          </div>
          <div className='field-update-input-wrapper'>
            <div className='field-update-input-title'>
              <IntlMessages id='common.address' />
              <span className='required'>*</span>
            </div>
            <div className={`field-update-address cursor-pointer no-drag ${address && 'isFill'} ${error === 'address' && 'error'}`} onClick={onHandleAddressPopup}>
              {address ? (
                <>
                  <span>{address}</span>
                  <img {...icArrowRight} alt='icArrowRight' style={{ width: 15, height: 15 }} />
                </>
              ) : (
                <>
                  <img {...icPin} alt='icPin' style={{ width: 15, height: 15 }} />
                  <span>
                    <IntlMessages id='field.add.update.address.search' />
                  </span>
                </>
              )}
            </div>
            <input
              className={`field-update-input ${error === 'address2' && 'error'}`}
              value={address2}
              onChange={e => {
                setError(null);
                onChangeFieldData('address2', e.target.value);
              }}
              placeholder={formatMessage({ id: 'order.add.address2.placeholder' })}
            />
          </div>
          {/* todo: 고객 연결 리뉴얼 이후 작업 */}
          {/* <div className="field-update-input-wrapper">
            <div className="field-update-input-title">
              <IntlMessages id="field.add.update.customer.connect" />
            </div>
            <div className="field-update-customer-connect-button cursor-pointer no-drag">
              <IntlMessages id="field.add.update.customer.connect.button" />
            </div>
            <div className="field-update-customer-connect-sub">
              <IntlMessages id="field.add.update.customer.connect.sub" />
            </div>
          </div> */}
          <div className='field-update-input-wrapper gap-8'>
            <div className='field-update-input-title'>
              <IntlMessages id='field.add.update.spaceType' />
            </div>
            <div className='field-update-space-type-wrapper'>
              <button className={`field-update-space-type-item ${spaceType === 'RESIDENTIAL' && 'active'}`} onClick={() => onChangeFieldData('spaceType', 'RESIDENTIAL')}>
                <IntlMessages id='field.add.update.spaceType.resident' />
              </button>
              <button className={`field-update-space-type-item ${spaceType === 'COMMERCIAL' && 'active'}`} onClick={() => onChangeFieldData('spaceType', 'COMMERCIAL')}>
                <IntlMessages id='field.add.update.spaceType.commercial' />
              </button>
            </div>
          </div>
          <div className='field-update-input-wrapper gap-8'>
            <div className='field-update-input-title'>
              <IntlMessages id='field.dateConstruct' />
            </div>
            <div className='field-update-date'>
              <DateForm
                value={dateConstructStart}
                onChange={({ value }) => {
                  onChangeFieldData('dateConstructStart', value);
                }}
                placeholder='sidebar.field.update.dateConstructStart.placeholder'
              />
              <div className='date-dash' />
              <DateForm
                value={dateConstructEnd}
                onChange={({ value }) => {
                  onChangeFieldData('dateConstructEnd', value);
                }}
                placeholder='sidebar.field.update.dateConstructEnd.placeholder'
              />
            </div>
          </div>
          {fieldId && (
            <div className='field-update-input-wrapper gap-8'>
              <div className='field-update-input-title'>
                <IntlMessages id='field.info.staff' />
              </div>
              <div
                className='field-update-staff-wrapper cursor-pointer no-drag'
                onClick={() => {
                  !isVietnam(user) ? setOpenStaffKoUpdatePopup(true) : setOpenStaffUpdatePopup(true);
                }}
              >
                <div className={`field-update-staff-content ${staffs.length === 0 && 'placeholder'}`}>
                  {staffs.length > 0 ? staffs.map(staff => staff.name).join(', ') : <IntlMessages id='field.add.update.staff.placeholder' />}
                </div>
                <img {...icArrowRight} alt='icArrowRight' />
              </div>
            </div>
          )}
          <div className='field-update-input-wrapper gap-8'>
            <div className='field-update-input-title'>
              <IntlMessages id='field.info.memo' />
            </div>
            <Input
              type='textarea'
              className='field-setting-basic-info-drawer-content-item-memo'
              onInput={handleTextareaHeight}
              value={memo}
              onChange={e => onChangeFieldData('memo', e.target.value)}
              placeholder={formatMessage({ id: 'field.info.memo' })}
            />
          </div>
        </div>
        <div className='field-update-buttons'>
          <button className='field-update-button button-gray' onClick={onClose}>
            <IntlMessages id='button.cancel' />
          </button>
          <button
            className='field-update-button button-black'
            onClick={() => {
              onConfirm(setError, onClose);
            }}
          >
            <IntlMessages id='common.done' />
          </button>
        </div>
      </div>
      <CommonDialog
        open={showCancelPopup}
        title={fieldId ? 'field.add.update.cancel.title' : 'field.add.update.cancel.create.title'}
        content='dashboard.field.account.book.cancel.content'
        confirmText='dashboard.field.account.book.cancel.button'
        cancelText='common.no'
        isReverse={true}
        needIntl={true}
        imageType='ex'
        onClose={() => {
          setShowCancelPopup(false);
        }}
        onConfirm={() => {
          setShowCancelPopup(false);
          onClose();
        }}
      />
      <AddressNewPopup
        open={openAddressPopup}
        onClose={() => setOpenAddressPopup(false)}
        onSelect={item => {
          setError(null);
          onChangeFieldData('address', item.address);
          onChangeFieldData('address2', item.address2);
          onChangeFieldData('latitude', item.latitude);
          onChangeFieldData('longitude', item.longitude);
        }}
      />
      <AddressVietnamPopup
        open={openAddressVietnamPopup}
        onClose={() => setOpenAddressVietnamPopup(false)}
        onSelect={item => {
          setError(null);
          onChangeFieldData('address', item.address);
          onChangeFieldData('address2', item.address2);
          onChangeFieldData('latitude', item.latitude);
          onChangeFieldData('longitude', item.longitude);
        }}
      />
      <UpdatePopup isOpen={openStaffUpdatePopup} onClose={() => setOpenStaffUpdatePopup(false)} staffs={staffs} fieldId={fieldId} refresh={refreshStaffs} />
      <KoUpdatePopup
        isOpen={openStaffKoUpdatePopup}
        onClose={() => setOpenStaffKoUpdatePopup(false)}
        staffs={staffs || []}
        fieldId={fieldId}
        refresh={refreshStaffs}
        deleteCallback={() => onClose()}
      />
    </Drawer>
  );
};

export default FieldAddUpdateDrawer;
